import { PanelRow, ToggleControl, FormTokenField, SelectControl } from '@wordpress/components'
import { dispatch, useSelect } from '@wordpress/data'
import { useState, useEffect } from '@wordpress/element';

import { __ } from '@wordpress/i18n'

export default ({dates, _dateIndex, _date, onUpdate, storeKey}) => {

    const updateDatesTimes = (data, _dateIndex) => {

        let _allDates = dates;
        _allDates[_dateIndex] = {..._allDates[_dateIndex], ...data }
        // console.log(storeKey)
        // console.log(_allDates)
        onUpdate(storeKey, _allDates );
    }
    let currentYear = moment( new Date() ).format('YYYY');
    let yearSuggestions = [];
    for (let index = 0; index < 10 ; index++) {
        yearSuggestions = [...yearSuggestions, `${parseInt( currentYear )+index}` ]
    }
    let monthSuggestions = ["January","February","March","April","May","June","July", "August","September","October","November","December"];
    let weekdaysSuggestions = ["Sunday","Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let rruleWeekdays = ["SU","MO", "TU", "WE", "TH", "FR", "SA"];
    let dateDaysSuggestions = [];
    for (let index = 1; index < 33 ; index++) {
        dateDaysSuggestions = [...dateDaysSuggestions, `${index}` ]
    }


    let selectedYears = 'undefined'!==typeof _date.years?_date.years.split(','): [];
    selectedYears = selectedYears.filter((year)=>{
        return yearSuggestions.includes(year);
    })
    

    let _selectedMonths = 'undefined'!==typeof _date.months?_date.months.split(','): [];
    let selectedMonths = [];
    _selectedMonths.filter((month)=>{
        if ('undefined' !== typeof monthSuggestions[month-1] ) {
            selectedMonths = [...selectedMonths, monthSuggestions[month-1] ]
        }
    })

    let selectedWeekdays = [];
    let _selectedWeekdays = 'undefined'!==typeof _date.days && 'every_days' !== _date.days?_date.days.split(','): [];
    _selectedWeekdays.filter((day)=>{
        let dIndex = _.indexOf(rruleWeekdays, day);
        if ('undefined' !== typeof weekdaysSuggestions[dIndex] ) {
            selectedWeekdays = [...selectedWeekdays, weekdaysSuggestions[dIndex] ]
        }
    })

    let selectedDateDays = 'undefined'!==typeof _date.date_days && 'every_date_days' != _date.date_days?_date.date_days.split(','): [];
    selectedDateDays = _.without( selectedDateDays, "");
    selectedDateDays = selectedDateDays.filter((date_day)=>{
        return selectedDateDays.includes(date_day);
    })

    return <>
        <PanelRow>
            <label>{ __( 'Enable recurring dates', 'wp-travel' ) }</label>
            <ToggleControl
                checked={ _date.is_recurring }
                onChange={ () => {
                    updateDatesTimes( { is_recurring: !_date.is_recurring }, _dateIndex );
                } }
            />
        </PanelRow>
        {_date.is_recurring&&<>
            <PanelRow className='recurring-every-year' 
                style={{display: "none"}}
            >
                <label>{ __( 'Recurring every year', 'wp-travel' ) }</label>
                <ToggleControl
                    checked={ 'every_year' == _date.years?true:false }
                    onChange={ (element) => {
                        updateDatesTimes( { years: !element?'':'every_year' }, _dateIndex );
                    } }
                />
            </PanelRow>

            { 'every_year' !== _date.years && <>
                <PanelRow>
                <label>{ __( 'Recurring specific years', 'wp-travel' ) }</label>
                <FormTokenField 
                    label=""
                    help=""
                    value={ selectedYears } 
                    suggestions={ yearSuggestions } 
                    onChange={ tokens => {
                        let filteredYears = tokens.filter((year)=>{
                            return yearSuggestions.includes(year);
                        })

                        updateDatesTimes( { years: filteredYears.join(',') }, _dateIndex );
                    }  }
                    placeholder={ __( 'Type a year', 'wp-travel' ) }
                /></PanelRow><hr/>
            </>}

            <PanelRow>
            <label>{ __( 'Recurring every month', 'wp-travel' ) }</label>
            <ToggleControl
                checked={ 'every_month' == _date.months?true:false }
                onChange={ (element) => {
                    updateDatesTimes( { months:  !element?'':'every_month' }, _dateIndex );
                } }
            />
        </PanelRow>

        { 'every_month' !== _date.months && <><PanelRow>
        <label>{ __( 'Recurring months', 'wp-travel' ) }</label>
        <FormTokenField 
            label=""
            help=""
            value={ selectedMonths } 
            suggestions={ monthSuggestions } 
            onChange={ tokens => {
                let filteredMonths = [];
                tokens.map((month)=>{
                    let mIndex = _.indexOf(monthSuggestions, month);
                    
                    if( monthSuggestions.includes(month) ){
                        filteredMonths = [...filteredMonths, mIndex+1];
                    }
                })

                updateDatesTimes( { months:  filteredMonths.join(',') }, _dateIndex );
            }  }
            placeholder={ __( 'Type a month', 'wp-travel' ) }
            /></PanelRow><hr/></>}

            <PanelRow>
                <label>{ __( 'Recurring weekdays/ Dates', 'wp-travel' ) }</label>
                <SelectControl
                    value={ _date.recurring_weekdays_type }
                    options={ [
                        { label: __( 'Recuring every day', 'wp-travel' ), value: '' },
                        { label: __( 'Specific weekdays', 'wp-travel' ), value: 'every_days' },
                        { label: __( 'Specific dates', 'wp-travel' ), value: 'every_date_days' },
                    ] }
                    onChange={ (val) => {
                        let  _dates_ = [];
                        if( 'every_days' === val ) {
                            _dates_ = {
                                ..._date,
                                date_days:'',
                                recurring_weekdays_type: val
                            }
                        } else if( 'every_date_days' === val ) {
                            _dates_ = {
                                ..._date,
                                days:'',
                                recurring_weekdays_type: val
                            }
                        } else {
                            _dates_ = {
                                ..._date,
                                days:'',
                                date_days:'',
                                recurring_weekdays_type: ''
                            }
                        }

                        updateDatesTimes(  _dates_ , _dateIndex );
                    } }
                />
            </PanelRow>

            {'every_days' === _date.recurring_weekdays_type&&<PanelRow>
                <label>{ __( 'Recurring specific weekdays', 'wp-travel' ) }</label>
                <FormTokenField 
                    label=""
                    help=""
                    value={ selectedWeekdays } 
                    suggestions={ weekdaysSuggestions } 
                    onChange={ tokens => {
                        
                        let filteredDays = [];
                        tokens.map((day)=>{
                            let dIndex = _.indexOf(weekdaysSuggestions, day);
                            
                            if( weekdaysSuggestions.includes(day) ){
                                filteredDays = [...filteredDays, rruleWeekdays[dIndex]];
                            }
                        })
                        updateDatesTimes(  {days: filteredDays.join(',')} , _dateIndex );
                }  }
                    placeholder={ __( 'Type a weekdays', 'wp-travel' ) }
                /></PanelRow>}

            {'every_date_days' === _date.recurring_weekdays_type&&<PanelRow>
                <label>{ __( 'Recurring specific dates', 'wp-travel' ) }</label>
                <FormTokenField 
                label=""
                help=""
                    value={ selectedDateDays } 
                    suggestions={ dateDaysSuggestions } 
                    onChange={ tokens => {
                        let filteredDateDays = tokens.filter((date_day)=>{
                            return dateDaysSuggestions.includes(date_day);
                        })

                        updateDatesTimes(  {date_days: filteredDateDays.join(',')} , _dateIndex );
                    }  }
                    placeholder={ __( 'Type a date', 'wp-travel' ) }
                /></PanelRow>}
        </>}
    </>
}